import { ResourceType } from '@ardoq/api-types';
import type { PermissionResourceType } from '@ardoq/api-types';
import styled from 'styled-components';
import {
  AgentIcon,
  DescriptionOutlinedIcon,
  ViewpointIcon,
  ScenarioIcon,
  SurveysIcon,
  WorkspaceIcon,
  DashboardIcon,
} from '@ardoq/icons';
import type { IconProps } from '@ardoq/icons';
import { capitalize } from '@ardoq/common-helpers';
import { s4 } from '@ardoq/design-tokens';

const RowIconWrapper = styled.span<{ $isDisabled?: boolean }>`
  svg {
    transform: translate(0, 25%);
    margin-right: ${s4};
  }
  opacity: ${({ $isDisabled = false }) => ($isDisabled ? 0.5 : null)};
`;

type ResourceNameDecoratorProps = Omit<IconProps, 'iconName'> & {
  onClick?: (resourceType: PermissionResourceType) => void;
  isDisabled?: boolean;
  resourceType: PermissionResourceType;
  resourceName: string;
  strongName?: boolean;
  withResourceTypeNamePrefix?: boolean;
};

const ICONS_MAP = {
  [ResourceType.WORKSPACE]: WorkspaceIcon,
  [ResourceType.SURVEY]: SurveysIcon,
  [ResourceType.SCENARIO]: ScenarioIcon,
  [ResourceType.REPORT]: DescriptionOutlinedIcon,
  [ResourceType.DASHBOARD]: DashboardIcon,
  [ResourceType.VIEWPOINT]: ViewpointIcon,
  [ResourceType.TRAVERSAL]: ViewpointIcon,
  [ResourceType.CUSTOM_AGENT]: AgentIcon,
};

export const ResourceNameDecorator = ({
  onClick,
  isDisabled = false,
  resourceType,
  resourceName,
  strongName = true,
  withResourceTypeNamePrefix = false,
}: ResourceNameDecoratorProps) => {
  const Icon = ICONS_MAP[resourceType];
  return (
    <RowIconWrapper
      onClick={() => !isDisabled && onClick && onClick(resourceType)}
      $isDisabled={isDisabled}
    >
      {withResourceTypeNamePrefix && capitalize(resourceType)}{' '}
      <Icon data-tooltip-text={capitalize(resourceType)}></Icon>
      {strongName ? <strong>{resourceName}</strong> : resourceName}
    </RowIconWrapper>
  );
};
